export const AUDIT = 'AUDIT'
export const ERROR = 'ERROR'
